var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90901 18.7197C7.61612 19.0126 7.61612 19.4874 7.90901 19.7803C8.2019 20.0732 8.67678 20.0732 8.96967 19.7803L16.5 12.25L8.96967 4.71967C8.67678 4.42678 8.2019 4.42678 7.90901 4.71967C7.61612 5.01256 7.61612 5.48744 7.90901 5.78033L14.3787 12.25L7.90901 18.7197Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronright);
export default __webpack_public_path__ + "static/media/Chevron right.069caa1e8e96a54280c10d066606a273.svg";
export { ForwardRef as ReactComponent };